import request from '@/utils/request'

export const detailApi = (data) => {
    return request({
        url: 'Agreements/byData',
        method: 'post',
        data
    })
}

export const saveApi = (data) => {
    return request({
        url: 'Agreements/save',
        method: 'post',
        data
    })
}